module.exports = __webpack_public_path__ + "00a25d57fe01bf2032fd237aac5ebed7.png";